/* T.TAiO: precio por pieza al cambiar de presentación, "Comprar ahora", menú "Compartir",
   estrellas → reseñas. */
(function () {


  // "Lo nuevo para tu negocio": iguala la altura de los textos de las tarjetas que quedan en la misma fila,
  // para que precio y botón queden alineados en cualquier tamaño de pantalla.
  function igualarLoNuevo() {
    var textos = [].slice.call(document.querySelectorAll('.discount-banner__container__content__texts'));
    textos.forEach(function (t) { t.style.minHeight = ''; });
    var filas = {};
    textos.forEach(function (t) {
      var k = Math.round(t.getBoundingClientRect().top + window.scrollY);
      (filas[k] = filas[k] || []).push(t);
    });
    Object.keys(filas).forEach(function (k) {
      var fila = filas[k], max = 0;
      fila.forEach(function (t) { max = Math.max(max, t.getBoundingClientRect().height); });
      if (fila.length > 1) fila.forEach(function (t) { t.style.minHeight = Math.ceil(max) + 'px'; });
    });
  }
  var esperaLoNuevo;
  ['load', 'resize'].forEach(function (ev) {
    window.addEventListener(ev, function () { clearTimeout(esperaLoNuevo); esperaLoNuevo = setTimeout(igualarLoNuevo, 120); });
  });
  document.addEventListener('DOMContentLoaded', igualarLoNuevo);

  function pintar(contenedor, datos) {
    contenedor.querySelectorAll('[data-tt]').forEach(function (s) {
      if (datos[s.dataset.tt] !== undefined) s.textContent = datos[s.dataset.tt];
    });
  }

  document.addEventListener('change', function (e) {
    // Tarjeta de colección: el valor elegido es el número de piezas (12, 30…)
    var card = e.target.closest && e.target.closest('.product-card');
    var tt = card && card.querySelector('[data-tt-card]');
    if (tt) {
      try {
        var d = JSON.parse(tt.dataset.ttCard)[e.target.value];
        if (d) pintar(tt, d);
      } catch (err) {}
      return;
    }
    // Ficha de producto: se lee la variante elegida del formulario
    setTimeout(function () {
      var input = document.querySelector('[id^="MainProduct"] form[action*="/cart/add"] [name="id"]');
      document.querySelectorAll('[data-tt-producto]').forEach(function (el) {
        var datos = (window.ttaioVariantes || {})[el.dataset.ttProducto];
        var d = datos && input && datos[input.value];
        if (d) pintar(el, d);
      });
    }, 80);
  });

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;

    // "Comprar ahora": usa el mismo botón del tema, que agrega y abre el carrito lateral
    // (ahí se contesta "¿Requieres factura?" y se da "Finalizar compra").
    if (t.closest('[data-tt-comprar]')) {
      var boton = document.querySelector('[id^="MainProduct"] product-form form[action*="/cart/add"] [type="submit"]');
      if (boton) boton.click();
      return;
    }

    // "Compartir": abre/cierra el menú de redes (WhatsApp, Facebook, Instagram, Mail, copiar liga…)
    var caja = t.closest('[data-tt-compartir-caja]');
    if (t.closest('[data-tt-compartir]')) {
      caja.classList.toggle('abierto');
      return;
    }
    // "Instagram": Instagram no acepta ligas desde páginas web, así que se copia la liga y se abre Instagram para pegarla
    var insta = t.closest('[data-tt-instagram]');
    if (insta && navigator.clipboard) navigator.clipboard.writeText(insta.dataset.ttInstagram);
    var copiar = t.closest('[data-tt-copiar]');
    if (copiar) {
      var listo = function () {
        var texto = copiar.textContent;
        copiar.textContent = '¡Liga copiada!';
        setTimeout(function () { copiar.textContent = texto; }, 1800);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(copiar.dataset.ttCopiar).then(listo, listo);
      return;
    }
    document.querySelectorAll('[data-tt-compartir-caja].abierto').forEach(function (c) {
      if (!c.contains(t)) c.classList.remove('abierto');
    });

    // Estrellas de la ficha: baja a la sección de reseñas
    if (t.closest('[data-tt-ir-resenas]')) {
      var destino = document.getElementById('resenas') || document.querySelector('[class^="prr-"], [class*=" prr-"]');
      if (destino) { e.preventDefault(); destino.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  }, true); // fase de captura: el tema detiene algunos clics antes de que lleguen al documento
})();

// Ancla fija "#marcas" para la sección "Nuestras Marcas" del inicio (la usa el botón "Marcas" de la búsqueda: /#marcas)
(function () {
  function ancla() {
    var sec = Array.prototype.find.call(document.querySelectorAll('[id*="__brands_grid"]'), function (s) {
      return /nuestras marcas/i.test(s.textContent);
    });
    if (!sec || document.getElementById('marcas')) return document.getElementById('marcas');
    var a = document.createElement('span');
    a.id = 'marcas';
    a.style.cssText = 'display:block;position:relative;top:-90px;height:0;';
    sec.insertBefore(a, sec.firstChild);
    return a;
  }
  function ir() {
    if (location.hash !== '#marcas') return;
    var a = ancla();
    if (!a) return;
    var cerrar = document.querySelector('.header-modal-search [class*="close"], .header-modal-search button[aria-label]');
    if (document.querySelector('.header-modal-search[open], .header-modal-search.active, .header-modal-search.is-open') && cerrar) cerrar.click();
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { a.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { ancla(); ir(); });
  else { ancla(); ir(); }
  window.addEventListener('load', ir);
  window.addEventListener('hashchange', ir);
})();

/* Celular: el botón del chat (Tidio) quedaba encima de la barra de abajo (Inicio, Tienda, Lista de deseos, Carrito).
   Se sube justo arriba de la barra mientras el chat está cerrado. Tidio vive en un shadow root, por eso se inyecta el estilo ahí. */
(function () {
  function barra() {
    var n = document.querySelector('footersticky-nav');
    return n && n.offsetHeight && getComputedStyle(n).display !== 'none' ? n.offsetHeight : 0;
  }
  function ajustar() {
    var host = document.getElementById('tidio-chat');
    if (!host || !host.shadowRoot) return false;
    var st = host.shadowRoot.getElementById('tt-sube-chat');
    if (!st) { st = document.createElement('style'); st.id = 'tt-sube-chat'; host.shadowRoot.appendChild(st); }
    var h = barra();
    st.textContent = h ? '#button.chat-closed{margin-bottom:' + (h + 4) + 'px!important}#tidio-chat-root .widgetLabel{bottom:' + (h + 11) + 'px!important}' : '';
    return true;
  }
  /* Tidio vuelve a dibujar su contenido; se revisa cada segundo que el ajuste siga puesto (es muy ligero) */
  setInterval(function () {
    var host = document.getElementById('tidio-chat');
    var css = host && host.shadowRoot && host.shadowRoot.getElementById('tt-sube-chat');
    if (!css || css.dataset.h != barra()) { ajustar(); css = host && host.shadowRoot && host.shadowRoot.getElementById('tt-sube-chat'); if (css) css.dataset.h = barra(); }
  }, 1000);
})();

/* Celular: el botón del chat (Shopify Inbox) quedaría encima de la barra de abajo (Inicio, Tienda, Lista de deseos, Carrito).
   Se sube justo arriba de la barra cuando la barra existe; en computadora y páginas sin barra queda donde lo pone la app. */
(function () {
  function barra() {
    var n = document.querySelector('footersticky-nav');
    return n && n.offsetHeight && getComputedStyle(n).display !== 'none' ? n.offsetHeight : 0;
  }
  setInterval(function () {
    var c = document.querySelector('shopify-chat');
    if (!c) return;
    var h = barra();
    if (c.dataset.ttBarra === String(h)) return;
    if (h) c.style.setProperty('--shopify-chat-activator-offset', (h + 12) + 'px');
    else c.style.removeProperty('--shopify-chat-activator-offset');
    c.dataset.ttBarra = h;
  }, 1000);
})();

/* Chat (Shopify Inbox): textos en inglés pasados a español, y el botón "Iniciar sesión" se aclaraba al pasar el mouse. Se deja como los botones de la página:
   azul medio normal y azul del logo al pasar el mouse. Sus estilos viven dentro del chat (shadow root), por eso se inyectan ahí. */
(function () {
  var CSS = '.sign-in-button:not(.sign-in-button--shop),.new-chat-popover__button--primary{background-color:#2E6DB4!important;opacity:1!important;transition:background-color .15s}' +
    '.sign-in-button:not(.sign-in-button--shop):hover:not(:active),.new-chat-popover__button--primary:hover:not(:active){background-color:#004A98!important;opacity:1!important}' +
    /* Celular: letra más grande (16 en vez de 14), ventana al 70% de alto (antes 80%), fondo blanco sólido y pegada abajo; la franja blanca tapa el hueco
       que dejaba ver la página debajo del chat en iPhone */
    '@media (max-width: 749px){#shopify-element-wrapper:not(.desktop-layout){--shopify-chat-font-size:16px}' +
    ':host(:not([mode="managed"])) #shopify-element-wrapper:not(.desktop-layout) .panel{--private-panel-cap-height:70dvh;--private-panel-optimal-height:70dvh;bottom:0!important;border-bottom-left-radius:0;border-bottom-right-radius:0;background:var(--shopify-chat-bg-color)!important;box-shadow:0 1px 3px rgba(0,0,0,.3),0 200px 0 0 var(--shopify-chat-bg-color)}}';
  /* Textos que la app deja en inglés (solo se cambia el texto completo exacto) */
  var ES = {
    'Start a new chat?': '¿Empezar un chat nuevo?',
    'Sign in to save your chat history, or continue without signing in.': 'Inicia sesión para guardar tu historial o continúa sin iniciar sesión.',
    'Continue without signing in': 'Continuar sin iniciar sesión',
    'View cart': 'Ver carrito',
    'Added': 'Agregado',
    'Back to chat': 'Volver al chat',
    'Create a new chat': 'Crear un chat nuevo'
  };
  function traducir(r) {
    var w = document.createTreeWalker(r, NodeFilter.SHOW_TEXT), n, t, m;
    while ((n = w.nextNode())) {
      t = n.data.trim();
      if (!t) continue;
      if (ES[t]) n.data = n.data.replace(t, ES[t]);
      else if ((m = t.match(/^(\d+) added to cart$/))) n.data = n.data.replace(t, m[1] === '1' ? '1 agregado al carrito' : m[1] + ' agregados al carrito');
    }
    r.querySelectorAll('[aria-label="Back to chat"],[aria-label="Create a new chat"]').forEach(function (e) { e.setAttribute('aria-label', ES[e.getAttribute('aria-label')]); });
  }
  function poner(r) {
    if (!r.getElementById('tt-chat-botones')) { var st = document.createElement('style'); st.id = 'tt-chat-botones'; st.textContent = CSS; r.appendChild(st); }
    traducir(r);
    r.querySelectorAll('*').forEach(function (e) { if (e.shadowRoot) poner(e.shadowRoot); });
  }
  setInterval(function () {
    var c = document.querySelector('shopify-chat');
    if (c && c.shadowRoot) poner(c.shadowRoot);
  }, 1000);
})();

/* Carrito: nunca se usa la página completa del carrito (/cart); siempre se abre el carrito lateral, ya actualizado.
   - Ligas a /cart (p. ej. "View cart" del chat) abren el lateral con lo que haya en el carrito.
   - Si alguien entra directo a /cart (correo, botón de regreso del pago), vuelve a la página anterior (o al inicio) y se abre el lateral.
     Si viene de la pantalla de pago (bolsa de arriba a la derecha), va al inicio con el lateral abierto; antes regresaba al pago (2026-10-20).
   El carrito lateral tiene lo mismo que la página: notas, código de descuento y "¿Requieres factura?". */
(function () {
  if (window.Shopify && Shopify.designMode) return;
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function esCarrito(u) {
    try { var x = new URL(u, location.href); return x.origin === location.origin && /^\/cart\/?$/.test(x.pathname.replace(raiz.replace(/\/$/, ''), '')); }
    catch (e) { return false; }
  }
  /* Si el chat está abierto, se minimiza (la conversación se conserva) para que no tape el carrito ni el botón de pagar */
  function minimizarChat() {
    function buscar(r) {
      var b = r.querySelector('button[aria-label="Cerrar chat"]');
      if (b && b.getBoundingClientRect().width > 0) return b;
      var t = r.querySelectorAll('*');
      for (var i = 0; i < t.length; i++) if (t[i].shadowRoot) { var x = buscar(t[i].shadowRoot); if (x) return x; }
      return null;
    }
    var c = document.querySelector('shopify-chat');
    var b = c && c.shadowRoot && buscar(c.shadowRoot);
    if (b) b.click();
  }
  function abrir() {
    var d = document.querySelector('cart-drawer');
    if (!d || !d.getSectionsToRender) return false;
    minimizarChat();
    var ids = d.getSectionsToRender().map(function (s) { return s.id; }).filter(function (id) { return document.getElementById(id) || id === 'cart-drawer'; });
    fetch(raiz + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sec) { d.renderContents({ sections: sec }); })
      .catch(function () { d.open(); });
    return true;
  }
  if (/^\/cart\/?$/.test(location.pathname.replace(raiz.replace(/\/$/, ''), ''))) {
    var ref = document.referrer, destino = raiz;
    try { if (ref && new URL(ref).origin === location.origin && !esCarrito(ref) && !/\/checkouts?\//.test(new URL(ref).pathname)) destino = ref; } catch (e) {}
    try { sessionStorage.setItem('tt-abrir-carrito', '1'); } catch (e) {}
    location.replace(destino);
    return;
  }
  var pendiente = false;
  try { pendiente = sessionStorage.getItem('tt-abrir-carrito') === '1'; sessionStorage.removeItem('tt-abrir-carrito'); } catch (e) {}
  if (pendiente) {
    /* 2026-10-20: se abre en cuanto el carrito lateral está listo (antes esperaba a que cargaran todas las imágenes: varios segundos) */
    var abrirYa = function () {
      if (window.customElements && customElements.whenDefined) customElements.whenDefined('cart-drawer').then(function () { abrir(); });
      else abrir();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abrirYa); else abrirYa();
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var ruta = e.composedPath ? e.composedPath() : [e.target];
    for (var i = 0; i < ruta.length; i++) {
      var a = ruta[i];
      if (a && a.tagName === 'A' && a.href) {
        if (!esCarrito(a.href) || (a.id && a.id.indexOf('cart-icon-bubble') > -1)) return;
        if (abrir()) { e.preventDefault(); e.stopPropagation(); }
        return;
      }
    }
  }, true);
})();

/* Búsqueda: solo productos (sin artículos del blog). Los buscadores del sitio mandan type=product, y si alguien llega a /search sin
   ese dato (liga vieja) se agrega. */
(function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var ruta = raiz.replace(/\/$/, '') + '/search';
  if (location.pathname.replace(/\/$/, '') === ruta) {
    var u = new URL(location.href);
    if (u.searchParams.get('q') !== null && !u.searchParams.get('type')) { u.searchParams.set('type', 'product'); location.replace(u.toString()); return; }
  }
  /* buscadores (action=/search) y formularios de filtros de la búsqueda (los que llevan el texto buscado "q") */
  function poner() {
    document.querySelectorAll('form').forEach(function (f) {
      var esBusqueda = (f.getAttribute('action') || '').indexOf('/search') > -1 || ((f.getAttribute('id') || '').indexOf('FacetFiltersForm') === 0 && f.querySelector('input[name="q"]'));
      if (!esBusqueda || f.querySelector('input[name="type"]')) return;
      var i = document.createElement('input'); i.type = 'hidden'; i.name = 'type'; i.value = 'product'; f.appendChild(i);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poner); else poner();
  /* los filtros se vuelven a dibujar al usarlos: se repone el dato */
  var pendiente = false;
  new MutationObserver(function () { if (pendiente) return; pendiente = true; requestAnimationFrame(function () { pendiente = false; poner(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Políticas legales: Shopify les pone un título fijo; se muestra el mismo nombre que la liga del footer. */
(function () {
  var T = { 'privacy-policy': 'Aviso de Privacidad', 'terms-of-service': 'Términos y Condiciones', 'refund-policy': 'Devoluciones y Cancelaciones', 'shipping-policy': 'Política de Envío' };
  var m = location.pathname.match(/^\/policies\/([a-z-]+)/);
  if (!m || !T[m[1]]) return;
  function poner() {
    var h = document.querySelector('.shopify-policy__title h1, .shopify-policy__container h1, main h1');
    if (h) h.textContent = T[m[1]];
    document.title = T[m[1]] + ' – T Taio Mayoreo';
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poner); else poner();
})();

/* Reseñas (Judge.me): al dar "Enviar Reseña" o "Siguiente" con un campo obligatorio vacío, el aviso "Este campo es obligatorio"
   salía arriba y en celular no se veía; ahora la ventana sube sola hasta el primer campo con error. */
(function () {
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.jdgm-write-review-modal__nav-btn-next')) return;
    setTimeout(function () {
      var err = Array.prototype.find.call(document.querySelectorAll('.jdgm-write-review-modal__field-error'), function (x) {
        return x.offsetParent && x.textContent.trim();
      });
      if (!err) return;
      var campo = err.closest('.jdgm-write-review-modal__form-group') || err;
      campo.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var input = campo.querySelector('input, textarea');
      if (input) { try { input.focus({ preventScroll: true }); } catch (x) {} }
    }, 150);
  }, true);
})();


/* T.TAiO 2026-10-20: la franja de WhatsApp del inicio abre en pestaña nueva para que el sitio siga abierto */
(function () {
  function abrirWhatsEnPestana() {
    document.querySelectorAll('a.banner__block-item__link[href*="wa.me/"]').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abrirWhatsEnPestana);
  else abrirWhatsEnPestana();
})();

